// 公共路由

export default [
  // 公共路由
  {
    path: 'SubCommon',
    name: 'SubCommon',
    component: () =>
    import(/* webpackChunkName: "SubCommon" */ '@/components/sub-task/common/common')
  },
  // 完善团队资料
  {
    path: 'PerfectTeam',
    name: 'PerfectTeam',
    component: () =>
    import(/* webpackChunkName: "PerfectTeam" */ '@/components/sub-task/common/perfect-team')
  },
  // 团队建设小锦囊
  {
    path: 'TeamTips',
    name: 'TeamTips',
    component: () =>
    import(/* webpackChunkName: "TeamTips" */ '@/components/sub-task/common/team-tips')
  },
  // 交易排行榜
  {
    path: 'RankingList',
    name: 'RankingList',
    component: () =>
    import(/* webpackChunkName: "TradRank" */ '@/components/sub-task/common/trad-rank')
  },
  // 交易排行榜
  {
    path: 'certificate',
    name: 'Certificate',
    component: () =>
    import(/* webpackChunkName: "TradRank" */ '@/components/sub-task/common/result')
  },
  // 成绩报告
  {
    path: 'promotionCard',
    name: 'promotionCard',
    component: () =>
    import(/* webpackChunkName: "SubExercise" */ '@/components/sub-task/common/promotion-card')
  },
  // 成绩报告
  {
    path: 'academic',
    name: 'academic',
    component: () =>
      import(/* webpackChunkName: "SubExercise" */ '@/components/sub-task/common/academic-card')
  },
  // 晋级结果
  {
    path: 'result',
    name: 'result',
    component: () =>
    import(/* webpackChunkName: "SubExercise" */ '@/components/sub-task/common/result')
  },
  // 练习
  {
    path: 'exercise',
    name: 'exercise',
    component: () =>
    import(/* webpackChunkName: "SubExercise" */ '@/components/sub-task/common/exercise')
  },
  // 考试
  {
    path: 'exam',
    name: 'exam',
    component: () =>
    import(/* webpackChunkName: "SubExam" */ '@/components/sub-task/common/exam')
  },
  // Sq考试
  {
    path: 'sqexam',
    name: 'sqexam',
    component: () =>
    import(/* webpackChunkName: "SubSqexam" */ '@/components/sub-task/common/sq-exam')
  },
  // 设备调试
  {
    path: 'equipmentCheck',
    name: 'equipmentCheck',
    component: () =>
    import(/* webpackChunkName: "SubSqexam" */ '@/components/sub-task/common/equipmentCheck')
  },
  // 准考证
  {
    path: 'admission',
    name: 'admission',
    component: () =>
    import(/* webpackChunkName: "SubAdmission" */ '@/components/sub-task/common/admission')
  },
  // 创建房间
  {
    path: 'room',
    name: 'Room',
    component: () =>
    import(/* webpackChunkName: "SubAdmission" */ '@/components/sub-task/room/join-create')
  },
  {
    path: 'honor',
    name: 'honor',
    component: () =>
      import(/* webpackChunkName: "SubAdmission" */ '@/components/sub-task/common/honor')
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/sub-task/sub-common.js